import HeaderSection from '../../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../../components/CockpitCards/CardTransparent';


export default function CancerDiseaseText() {

    
    return (

      <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Do your genes carry variants that could" 
            headline_grey = "increase your risk"
            headline_p2 = "for certain types of cancer?"

            text1 = "This section focuses on identifying genetic variants that may increase your risk for certain hereditary cancers. We analyze disease-specific panels curated by experts to scan key genes known to be associated with cancer susceptibility."
            text2 = "Understanding your genetic risk can help guide important next steps — including preventive strategies, lifestyle changes, early detection programs, and personalized healthcare planning."
            text3 = "Even if a variant is found, it does not mean you will develop cancer, but knowing about an increased risk can help you and your doctor take action early when it matters most."

            />
    }/>
            
  )
}